import React from 'react';
import Link from 'components/Link';
import PreFooter from './PreFooter';
import Navigation from './Navigation';
import TagManagerService from 'services/TagManager';
import { footerTxt } from 'config/translate/variables';
import Subscribe from './Subscribe';
import style from './style.scss'; //NOSONAR

const Footer = () => {

    const clickLinkFooter = (action, tag) => {
        TagManagerService.footer(action, tag);
    };

    return(
        <footer className="footer">
            <PreFooter />
            <Subscribe />
            <div className="footer-content">
                <Navigation />
                <div className="footer-copyright">
                    <div className="footer-copyright-content">
                        <span className="footer-copyright-text">{footerTxt.copyright}</span>

                        <div className="footer-copyright-links-wrap">
                            <Link to="/institucional/terminos-condiciones" className="footer-copyright-link" onClick={() => clickLinkFooter('Términos y Condiciones', '/institucional/terminos-condiciones')}>Términos y Condiciones</Link>
                            <span className="copyright-line"> | </span>
                            <Link to="/institucional/seguridad-privacidad" className="footer-copyright-link" onClick={() => clickLinkFooter('Seguridad y Privacidad', '/institucional/seguridad-privacidad')}>Seguridad y Privacidad</Link>
                            <span className="copyright-line"> | </span>
                            <Link to="https://www.cencosud.com/cencosud/site/artic/20160216/asocfile/20160216190212/codigo_etica_chile__3_10v3.pdf" className="footer-copyright-link" onClick={() => clickLinkFooter('Código de ética', 'https://assets.jumbo.cl/uploads/2019/07/codigo-etica-grupo-cencosud.pdf?_ga=2.137179059.280401361.1598897788-229219014.1588944841')}>Código de ética</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default Footer;
